import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/sidebar/Sidebar';
import Header from '../../components/Layout/Header/Header';
import SearchPopup from '../../components/SearchPopUp/SearchPopup';
import { postsService, getMediaBaseUrl, Post } from '../../api/api.service';
import '../../styles/global.css';
import '../postpage/PostPage.css';

const PostPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [post, setPost] = useState<Post | null>(null);
  const [author, setAuthor] = useState('Unknown');
  const [image, setImage] = useState('');
  const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false);
  const navigate = useNavigate();

  const mediaBaseUrl = getMediaBaseUrl();
  const fallbackImage = `${mediaBaseUrl}/wp-content/uploads/2025/10/placeholder.jpg`;

  const getFeaturedImage = (post: any): string => {
    const media = post._embedded?.['wp:featuredmedia'];
    if (!media) return fallbackImage;
    const mediaObj = Array.isArray(media) ? media[0] : media;
    return mediaObj.source_url ||
      mediaObj.media_details?.sizes?.full?.source_url ||
      fallbackImage;
  };

  useEffect(() => {
    if (!id) return;

    const fetchPost = async () => {
      try {
        const postData = await postsService.getPost(id);
        setPost(postData);
        setAuthor(postData._embedded?.author?.[0]?.name || 'Unknown');
        setImage(getFeaturedImage(postData));
      } catch (err) {
        console.error("Error fetching post:", err);
      }
    };

    fetchPost();
  }, [id, fallbackImage]);

  const handleSearch = (query: string) => {
    navigate(`/search?s=${encodeURIComponent(query)}`);
  };

  if (!post) return <div style={{ textAlign: 'center', marginTop: 60 }}>Loading post...</div>;

  const postContent = post.content?.rendered || '';

  return (
    <>
      <Header onSearchClick={() => setIsSearchPopupOpen(true)} />
      <SearchPopup
        isOpen={isSearchPopupOpen}
        onClose={() => setIsSearchPopupOpen(false)}
        onSearch={handleSearch}
      />

      <main className="post-page">
        <section className="post-content-wrapper">
          <div className="post-main">
            <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
            <img src={image} alt={post.title.rendered} />
            <div
              className="post-body"
              dangerouslySetInnerHTML={{ __html: postContent }}
            />
            <p className="post-meta">
              By {author} • {new Date(post.date).toDateString()}
            </p>
          </div>

          <aside className="post-sidebar">
            <Sidebar />
          </aside>
        </section>
      </main>
    </>
  );
};

export default PostPage;
